import { store } from '@/app/store';
import { getRepliedMessageById, setRepliedMessage } from '@/features/chats/model';
import { getUserIdFromJid } from '@/shared/utils';
import { resolveMessageById } from './fetchMessageById';
/**
 * Fetch a single message by its ID and store it in the repliedMessages slice.
 *
 * Lookup order:
 * 1. Redux (repliedMessages slice) — fastest, in-memory
 * 2. IndexedDB — offline / cached
 * 3. API — authoritative fallback
 *
 * @param {string} msgId - The message ID to fetch
 * @param {string} chatJid - The JID of the chat the message belongs to
 * @returns {Promise<Object|null>} The message data or null if not found
 */

export const fetchReplyMessage = async (msgId, chatJid, isEditedMessage = false) => {
   if (!msgId || !chatJid) return null;

   const chatId = getUserIdFromJid(chatJid);
   if (!isEditedMessage) {
      const repliedMessage = getRepliedMessageById(msgId);
      if (repliedMessage) return repliedMessage;
   }

   const message = await resolveMessageById(msgId, chatId, chatJid);

   if (message) {
      store.dispatch(setRepliedMessage({ msgId, data: message }));
   }

   return message ?? null;
};
